import { render, staticRenderFns } from "./TopicLabelDropdown.vue?vue&type=template&id=6e4c0af4&scoped=true&"
import script from "./TopicLabelDropdown.vue?vue&type=script&lang=js&"
export * from "./TopicLabelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TopicLabelDropdown.vue?vue&type=style&index=0&id=6e4c0af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c0af4",
  null
  
)

export default component.exports